"use strict"

/**
 * @typedef postalInfo
 * @property {string} name
 * @property {?string} org
 * @property {{street: ?string[], city: string, sp: ?string, pc: ?string, cc: string}} addr
 */

/**
 * @typedef eppContact
 * @property {?string} [id]
 * @property {postalInfo} postalInfo
 * @property {string} email
 * @property {{[x: string]: string} | null} extension
 * @property {?string} [voice]
 */

 /**
  * This is a BS compatibility wrapper around EPP contacts
  */
class BSContact {
    /**
     *
     * @param {?eppContact} contact_in
     */
    constructor(contact_in) {
        this.businessType = {
            fields: {
                company_name: false,
                trading_name: false,
                company_number: false
            }
        }
        if(contact_in) {
            this.eppContact = contact_in
            this.eppContact.voice = this.eppContact.voice || null
        } else {
            this.eppContact = {
                id: null,
                postalInfo: {
                    name: null,
                    org: null,
                    addr: {
                        street: ["", "", ""],
                        city: null,
                        sp: null,
                        pc: null,
                        cc: null,
                    },
                },
                voice: "",
                email: null,
                extension: {},
            }
        }
        this.valid = true
        this.submitted = true
    }
    get address() {
        return this.street ? this.street.join("\n") : null
    }
    set address(v) {
        if(v === null) {
            this.eppContact.postalInfo.addr.street = null
        } else {
            this.eppContact.postalInfo.addr.street = v.split(/\n/)
        }
    }
    get cc() {
        return this.eppContact.postalInfo.addr.cc
    }
    set cc(v) {
        this.eppContact.postalInfo.addr.cc = v
    }
    get city() {
        return this.eppContact.postalInfo.addr.city
    }
    set city(v) {
        this.eppContact.postalInfo.addr.city = v
    }
    get company_name() {
        return this.eppContact.postalInfo.org
    }
    set company_name(v) {
        this.eppContact.postalInfo.org = v
    }
    get company_number() {
        return this.eppContact.extension ? this.eppContact.extension["co-no"] : ""
    }
    set company_number(v) {
        this.eppContact.extension = this.orderedExtension(
            Object.assign(
                this.eppContact.extension || {},
                {"co-no": v}
            )
        )
    }
    get email() {
        return this.eppContact.email
    }
    set email(v) {
        this.eppContact.email = v
    }
    get extension() {
        return this.eppContact.extension
    }
    set extension(v) {
        this.eppContact.extension = v
    }
    get id() {
        return this.eppContact.id
    }
    get name() {
        return this.person_name
    }
    set name(v) {
        this.person_name = v
    }
    get nominet_contact_type() {
        return(
            this.eppContact.extension &&
            ("type" in this.eppContact.extension) &&
            this.eppContact.extension.type ||
            ""
        )
    }
    set nominet_contact_type(v) {
        var newTypeData = this.orderedExtension(
            Object.assign(
                this.eppContact.extension || {},
                {type: v}
            )
        )
        if( newTypeData.type == "OTHER"){
            newTypeData['co-no'] = "";
        }
        this.eppContact.extension = newTypeData;
    }
    get organisation() {
        return this.company_name
    }
    set organisation(v) {
        this.company_name = v
    }
    get pc() {
        return this.eppContact.postalInfo.addr.pc
    }
    set pc(v) {
        this.eppContact.postalInfo.addr.pc = v
    }
    get person_name() {
        return this.eppContact.postalInfo.name
    }
    set person_name(v) {
        this.eppContact.postalInfo.name = v
    }
    get sp() {
        return this.eppContact.postalInfo.addr.sp
    }
    set sp(v) {
        this.eppContact.postalInfo.addr.sp = v
    }
    get street() {
        return this.eppContact.postalInfo.addr.street || []
    }
    set street(v) {
        this.eppContact.postalInfo.addr.street = v
    }
    get telephone() {
        return this.voice
    }
    set telephone(v) {
        this.voice = v
    }
    get trading_name() {
        return this.eppContact.extension ? this.eppContact.extension["trad-name"] : ""
    }
    set trading_name(v) {
        this.eppContact.extension = this.orderedExtension(
            Object.assign(
                this.eppContact.extension || {},
                {"trad-name": v}
            )
        )
    }
    get uid() {
        return JSON.stringify(
            Object.assign(
                {},
                this,
                {
                    extension: null,
                    id: null,
                    roid: null,
                }
            )
        )
    }
    get voice() {
        return this.eppContact.voice
    }
    set voice(v) {
        this.eppContact.voice = v
    }
    /**
     *
     * @param {string} domain_type
     * @return {eppContact}
     */
    eppContactForType(domain_type) {
        if(
            domain_type == "nominet" &&
            !(
                this.eppContact.extension &&
                ("type" in this.eppContact.extension) &&
                this.eppContact.extension.type
            )
        ) {
            //@ts-ignore
            return {
                ...this.eppContact,
                extension: this.orderedExtension({
                    ...this.eppContact.extension || {},
                    type: "OTHER"
                }),
            }
        } else {
            //@ts-ignore
            return this.eppContact
        }
    }
    /**
     *
     * @param {string} domain_type
     */
    nonEPPContactForType(domain_type) {
        let extension
        if(
            domain_type == "nominet" &&
            !(
                this.eppContact.extension &&
                ("type" in this.eppContact.extension) &&
                this.eppContact.extension.type
            )
        ) {
            extension = this.orderedExtension(Object.assign(
                {},
                this.eppContact.extension || {},
                {
                    type: "OTHER"
                }
            ))
        } else {
            extension = this.eppContact.extension
        }
        return {
            name: this.name,
            organisation: this.company_name || this.name,
            address: this.address,
            city: this.city,
            sp: this.sp,
            pc: this.pc,
            cc: this.cc,
            telephone: this.telephone,
            email: this.email,
            extension: extension,
        }
    }
    /**
     * @param {{[x: string]: string}} extension_in
     * @returns {{[x: string]: string}}
     */
    orderedExtension(extension_in) {
        /** @type {{[x: string]: string}} */
        const out = {}
        const ordered_fields = ["trad-name", "type", "co-no"]
        ordered_fields.filter(
            field =>
                extension_in.hasOwnProperty(field) &&
                extension_in[field] !== null
        ).forEach(field => {
            out[field] = extension_in[field]
        })
        return out
    }
}
